import { ESTIMATED_RATE_KEY, } from "../types/section12.js";
/**
 * Returns `true` when a payment request is still in "estimated" mode
 * (i.e. the AMHP team's organisation did not have precise payments enabled
 * at creation, and the amount has not yet been confirmed).
 *
 * Detected by checking whether any configured-rate item uses the
 * `"estimated"` key *and* still has a zero amount. Once an admin confirms the
 * amount (which sets `amountPence` but leaves the `"estimated"` key in place),
 * the request is no longer estimated and the real total should be shown. This
 * matches the backend's definition in `checkAutoBillEligibility`.
 */
export function isUnconfirmedEstimatedPaymentRequest(request) {
    return request.items.some((item) => item.itemType === "configured-rate" &&
        item.configuredRateKey === ESTIMATED_RATE_KEY &&
        item.amountPence === 0);
}
//# sourceMappingURL=section12PaymentRequest.js.map